import { call, put, select, takeLatest } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import localizationAPI from '../../api/localization';
import { Types, Creators as LocalizationCreators } from '../../reducers/localization';
import { Creators as StoresCreators } from '../../reducers/stores';
import getState from '../../utils/getState';

function formatAddressGoogleApi(arr = []) {
  const address = {};

  arr.map((addr) => {
    if (addr.types.includes('street_number')) {
      address.streetNumber = addr.long_name;
    }

    if (addr.types.includes('route')) {
      address.streetName = addr.long_name;
    }

    if (addr.types.includes('administrative_area_level_2')) {
      address.city = addr.long_name;
    }

    if (addr.types.includes('administrative_area_level_1')) {
      address.stateShort = addr.short_name;
      address.stateLong = addr.long_name;
    }

    if (addr.types.includes('postal_code')) {
      address.postalCode = addr.long_name.replace('-', '');
    }

    if (addr.types.includes('sublocality')) {
      address.neighborhood = addr.long_name;
    }

    return null;
  });

  return address;
}

function* geoEncodedRequest({ lat, lng, sellerId }) {
  try {
    const { results } = yield call(localizationAPI.geocode, {
      key: 'AIzaSyDwmgDBDhJprD_F73yRwRqM1-8VxBoqvio',
      latlng: `${lat},${lng}`,
      result_type: 'street_address',
      language: 'pt-BR',
    });

    if (!results[0]) throw 'Não foi possível encontrar um endereço usando sua geolocalização.';

    // eslint-disable-next-line camelcase
    const { address_components, formatted_address } = results[0];

    const address = formatAddressGoogleApi(address_components);

    yield put(
      LocalizationCreators.geoEncodedSuccess({
        ...address,
        addresFormated: formatted_address,
        sellerId,
      })
    );

    if (sellerId) {
      const {
        app: { asPath },
        cart: { sellers },
        delivery: { selectedDelivery },
        stores: { selectedStore },
      } = yield select(getState);

      if (asPath.includes('checkout')) {
        // eslint-disable-next-line no-restricted-syntax
        for (const seller of sellers) {
          const id = seller.getIn(['seller', 'id']);

          if (selectedDelivery.getIn([id, 'isStore']) && (id === sellerId || !selectedStore.getIn([id]))) {
            yield put(StoresCreators.storesRequest(id, address.postalCode));
          }
        }
      }
    }
  } catch (error) {
    yield put(LocalizationCreators.geoEncodedFailed(formatError(error)));
  }
}

export default function* watchGeoEncodedRequest() {
  yield takeLatest(Types.GEO_ENCODED_REQUEST, geoEncodedRequest);
}
